import React, { useEffect, useState } from "react";

function useIsSafari() {
  const [isSafari, setIsSafari] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent;
    const isSafariBrowser =
      /^((?!chrome|android).)*safari/i.test(ua) &&
      !ua.toLowerCase().includes("crios");
    setIsSafari(isSafariBrowser);
  }, []);

  return isSafari;
}

function SmartSVG({ SvgComponent, imgSrc, alt, className }) {
  const isSafari = useIsSafari();

  return isSafari ? (
    <img src={imgSrc} alt={alt || ""} className={className} />
  ) : (
    <SvgComponent className={className} />
  );
}

export default SmartSVG;
